module.exports = __webpack_public_path__ + "img/child-app-bg.f1864561.svg";